



























import {Vue, Component, Prop} from 'vue-property-decorator'
import {SceneShot, StillShot, TitleShot, VideoShot} from '@/store/shots'
import AddShotStillForm from '@/components/Shots/AddShotStillForm.vue'
import AddShotVideoForm from '@/components/Shots/AddShotVideoForm.vue'
import AddShotSceneForm from '@/components/Shots/AddShotSceneForm.vue'
import AddShotTitleForm from '@/components/Shots/AddShotTitleForm.vue'

@Component({
  name: 'add-shot-dialog',
  components: {
    AddShotStillForm, AddShotVideoForm, AddShotSceneForm, AddShotTitleForm
  }
})
export default class AddShotDialog extends Vue {
  @Prop() open!: boolean
  // Note: This prop uses parent component v-model value and is modified by child form components.
  @Prop() value!: StillShot | VideoShot | SceneShot | TitleShot
  valid = false

  get dialogOpen() {
    return this.open
  }

  set dialogOpen(value: boolean) {
    if (!value)
      this.$emit('close')
  }
}
